import { render } from "./msa-ethos.vue?vue&type=template&id=292eb095&scoped=true"
import script from "./msa-ethos.vue?vue&type=script&lang=js"
export * from "./msa-ethos.vue?vue&type=script&lang=js"

import "./msa-ethos.vue?vue&type=style&index=0&id=292eb095&scoped=true&lang=css"
import "./msa-ethos.vue?vue&type=style&index=1&id=292eb095&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292eb095"]])

export default __exports__